// The two rules every team-name writer shares: what counts as the same name,
// and what InLeague's team-season PUT will refuse. Used by the coach portal's
// rename (SPA and Scheduler) and the trophy script, so all three agree.

/** Trimmed, inner whitespace collapsed; null for blank. Case is kept. */
export function normalizeTeamName(raw: string | null | undefined): string | null {
  const s = (raw ?? '').trim().replace(/\s+/g, ' ')
  return s === '' ? null : s
}

/** InLeague's team-season PUT refuses a name it calls "emoji or symbol
 *  characters" (HTTP 400, validator UdfValidatorWithDynamicMsg, seen
 *  2026-10-04). The exact rule is undocumented; Unicode's emoji and symbol
 *  classes approximate it, plus the joiners that build emoji. `&`, `'` and `!`
 *  are punctuation here and untested against InLeague; if InLeague refuses one
 *  of those, the push stops at that team and nothing after it is written. */
const REFUSED_CHARS = /[\p{Extended_Pictographic}\p{S}\u200D\uFE0F]/u

export function inleagueWillRefuse(name: string): boolean {
  return REFUSED_CHARS.test(name)
}
